import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BodyImageI } from '../../../interfaces/body/body-img.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { BodyImgService } from '../../../services/body-img.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-user-body-modal',
  templateUrl: './user-body-modal.component.html',
  styleUrls: ['./user-body-modal.component.scss']
})
export class UserBodyModalComponent implements OnInit {

  @Input() user: UserI;
  @Output() qualificationSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  public usersBodies: BodyImageI[];
  public loadingBodies = false;
  sendingBody = false;
  @Input() needSelfLoadBodies: boolean;

  constructor(
    private messageService: MessageService,
    private bodyServ: BodyImgService,
  ) {
  }

  ngOnInit(): void {
    if (this.needSelfLoadBodies === true) {
      this.loadFoodUsr();
    }
  }

  loadFoodUsr() {
    this.loadingBodies = true;

    this.bodyServ.getUserBodyImgs(this.user.id).subscribe(res => {
      if (res.ok === true) {
        this.usersBodies = res.images;
      }
      this.loadingBodies = false;
    }, error => {
      this.loadingBodies = false;
      console.log(error);
    });
  }

  emitComment(event) {
    this.qualificationSubmit.emit(event);
  }

  onClose() {
    this.closeModal.emit();
  }


}
